<mat-expansion-panel>
  <mat-expansion-panel-header>
    <mat-panel-title>
      {{tourOperator.name}} @if (tourOperator.doc_link) {
      <a class="material-icons" [href]='appService.getAbsolutePath(tourOperator.doc_link)' target="_blank">help</a>
    }
  </mat-panel-title>
  <mat-panel-description>
    @if ((tourOperator.integration && tourOperator.integration.enabled) || tourOperator.active) {
      <span>Attivo</span>
    }
    @if ((!tourOperator.integration || !tourOperator.integration.enabled) && !tourOperator.active) {
      <span>Non attivo</span>
    }
  </mat-panel-description>
</mat-expansion-panel-header>
@if (tourOperator.type != 'internal') {
  @if (tourOperator.activating) {
    <mat-progress-bar mode='indeterminate'></mat-progress-bar>
  }
  @if (!tourOperator.integration && (tourOperator.id || tourOperator.activable)) {
    <button mat-flat-button color='accent' (click)='createTripPackageIntegration()' [disabled]='tourOperator.activating'>Attiva</button>
  }
  @if (!tourOperator.id && !tourOperator.activable) {
    <p>Per attivare questa integrazione è richiesto che l'amministratore configuri la connessione al servizio esterno.</p>
  }
  @if (tourOperator.integration) {
    <dataset-edit
      [inputRecord]='tourOperator.integration'
      [parentDatasetACS]='datasetACS'
      [datasetCode]='datasetACS.datasetCode'
      [showTitle]="false"
      [autoFetchData]="true"
      [routed]='false'
      (updated)='integrationUpdated($event)'
    ></dataset-edit>
  }
  @if (tourOperator.integration && tourOperator.code === "booking_engine") {
    <a [href]="appService.getBaseServerAddressRoot() + '/preview/d/' + tourOperator.integration.domain.id + '/detail/trip_packages/' + tourOperator.integration.trip_package_id" target="_blank" mat-flat-button color='accent'>Visualizza prodotto</a>
  }
  @if (tourOperator.code === "tangerine") {
    <dataset-list
      datasetCode='domain_packages'
      [parentDatasetACS]='datasetACS'
      [showTitle]='false'
      [viewConfig]='domainPackageViewConfig'
			[filters]='{
				trip_package_id: datasetRS.recordId,
				tour_operator_id: tourOperator.id,
				contextual_domain_id: datasetACS.getValueFromKeyPath("contextual_domain_id"),
				without_parent: 1
			}'
    ></dataset-list>
  }
  @if (tourOperator.integration && tourOperator.code === "tour-cms") {
    <dataset-list
      datasetCode='meeting_point_list_to_references'
      [parentDatasetACS]='datasetACS'
      [showTitle]="false"
      [autoFetchData]="true"
      [filters]='{trip_package_id: datasetRS.recordId, tour_operator_id: tourOperator.id}'
    ></dataset-list>
  }
  @if (tourOperator.code == 'xola') {
    <p>
      ATTENZIONE! Inserire sempre un campo tra Lista punti di ritrovo o Orario di partenza
    </p>
  }
  @if (tourOperator.integration && ['viator', 'gyg', 'bokun','xola'].includes(tourOperator.code)) {
    <dataset-list
      datasetCode='actual_trip_groups'
      [parentDatasetACS]='datasetACS'
      [showTitle]="false"
      [autoFetchData]="true"
      [filters]='{trip_package_id: datasetRS.recordId, tour_operator_code: tourOperator.code}'
    ></dataset-list>
  }
}
@if (tourOperator.code == 'website') {
  @if (tourOperator.activating) {
    <mat-progress-bar mode='indeterminate'></mat-progress-bar>
  }
  <form-viewer
    [record]='websiteFormData'
    [dataContainerService]='datasetACS'
    [formConfig]='websiteForm'
    (valueChanges)="onWebsiteFormChanges($event)"
  ></form-viewer>
}
@if (tourOperator.code == 'booking_widget') {
  @if (tourOperator.message) {
    <p>{{tourOperator.message}}</p>
  }
  <p>Codice da copiare nella pagina:</p>
  <form-viewer
    [record]=''
    [dataContainerService]='datasetACS'
    [formConfig]='widgetForm'
    (valueChanges)="widgetOptions($event)"
  ></form-viewer>
  <code>{{tourOperator.snippet}}</code>
  <div style="margin-top:10px">
    <button (click)="openWidgetDialog()" mat-raised-button>{{ 'Vedi anteprima' | translate }}</button>
  </div>
}
</mat-expansion-panel>